import { render, staticRenderFns } from "./remnantOrder5.vue?vue&type=template&id=123059bf&scoped=true&"
import script from "./remnantOrder5.vue?vue&type=script&lang=js&"
export * from "./remnantOrder5.vue?vue&type=script&lang=js&"
import style0 from "./remnantOrder5.vue?vue&type=style&index=0&id=123059bf&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123059bf",
  null
  
)

export default component.exports